import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Library = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="library"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)" fill={fill}>
        <path d="M18.333 15.834v-3.333a.833.833 0 00-.833-.833H5.833A.833.833 0 005 12.5v3.333h13.333zM5 17.5V45h13.333V17.5H5zm10 10.834H8.333A.833.833 0 017.5 27.5v-6.666c0-.46.373-.834.833-.834H15c.46 0 .833.374.833.834V27.5c0 .46-.373.834-.833.834zM5 50v4.167c0 .46.373.833.833.833H17.5c.46 0 .833-.373.833-.833V50H5zM5 46.666h13.333v1.667H5v-1.666zM20 46.666h10.833v1.667H20v-1.666zM30.833 8.334v-2.5A.833.833 0 0030 5.001h-9.167a.833.833 0 00-.833.833v2.5h10.833zM20 14.168h10.833V45H20V14.168zM20 50v4.167c0 .46.373.833.833.833H30c.46 0 .833-.373.833-.833V50H20zM20 10.001h10.833v2.5H20V10zM32.48 22.257l.445 1.712 14.113-3.764-.446-1.711-14.112 3.763zM39.444 48.953l14.112-3.764-.894-3.425-14.113 3.763.895 3.426zM52.242 40.151l-4.783-18.333-14.113 3.764 4.782 18.333 14.114-3.764z" />
        <path d="M32.059 20.644l14.112-3.762-1.197-4.59a.852.852 0 00-1.025-.6l-12.5 3.334a.84.84 0 00-.591 1.016l1.2 4.602zM53.977 46.802l-14.114 3.763.994 3.81a.836.836 0 00.392.508c.126.076.27.117.417.117a.966.966 0 00.216-.025l12.5-3.333a.84.84 0 00.592-1.017l-.997-3.823z" />
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" transform="translate(5 5)" d="M0 0h50v50H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
/* eslint-enable max-len */

Library.defaultProps = {
  className: null,
};

Library.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Library;
